import { Breadcrumb } from '../../../components/Breadcrumb';
import { SettingsMenu, type SettingsMenuEntry } from '../../../components/settings/SettingsMenu';
import { CASH_CATALOGS } from '../cashCatalogTypes';

/*
  One row per vocabulary, built from the same descriptor the routes read — so a vocabulary
  cannot appear here with no page behind it.
*/
const ENTRIES: SettingsMenuEntry[] = CASH_CATALOGS.map((catalog) => ({
  key: catalog.slug,
  label: catalog.label,
  description: catalog.description,
  icon: catalog.icon,
  to: catalog.settingsPath,
  permission: 'cash-catalogs.read',
}));

/**
 * Cash Division → Settings: a menu of what the division configures. An extension of the
 * sidebar, which is what keeps the rail at one entry per module.
 */
export function CashDivisionSettingsPage() {
  return (
    <div className="flex h-full min-h-0 min-w-0 flex-col bg-slate-50">
      <Breadcrumb segments={['Cash Division', 'Settings']} />

      <div className="modern-scrollbar min-h-0 flex-1 overflow-y-auto overflow-x-hidden p-4">
        <div className="mx-auto flex max-w-3xl flex-col gap-3">
          {/*
            One line saying what the menu cannot: a request picks one of each, so both lists
            have to hold a row before one can be raised.
          */}
          <p className="text-xs text-slate-500">
            What a request to the Cash Division draws on. Every request names a transaction type
            and a payment type, so both lists need at least one entry before a request can be
            raised.
          </p>

          <SettingsMenu entries={ENTRIES} />
        </div>
      </div>
    </div>
  );
}
